import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ArrowDown } from "lucide-react";
import { useSelector } from "react-redux";
import {
  cartProductsSelector,
  totalCartSelector,
} from "../modules/cart/selectors";
import { formatPrice } from "../utils/format";
import "./floatingCart.css";

function FloatingCart({ targetRef }) {
  const cart = useSelector(cartProductsSelector);
  const total = useSelector(totalCartSelector);
  const [cartVisible, setCartVisible] = useState(true);

  useEffect(() => {
    const target = targetRef.current;
    if (!target || !window.IntersectionObserver) return;

    const observer = new IntersectionObserver(([entry]) => {
      setCartVisible(entry.isIntersecting);
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [targetRef]);

  if (!cart.length || cartVisible) return null;

  const quantity = cart.reduce((sum, product) => sum + product.qty, 0);
  const preview = cart
    .map((product) => `${product.qty} × ${product.name}`)
    .join(", ");

  function showCart() {
    const target = targetRef.current;
    if (!target) return;
    target.focus({ preventScroll: true });
    target.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
      block: "start",
    });
  }

  return createPortal(
    <aside className="floating-cart" aria-label="Podgląd koszyka">
      <div className="floating-cart__summary">
        <div className="floating-cart__details">
          <strong>
            {quantity} szt. · {formatPrice(total)} zł
          </strong>
          <span>{preview}</span>
        </div>
      </div>
      <button type="button" onClick={showCart} aria-controls="menu-cart">
        Do koszyka <ArrowDown size={16} aria-hidden="true" />
      </button>
    </aside>,
    document.body,
  );
}

export default FloatingCart;
